import {useEffect} from 'react';
import logo from './logo.svg';
import {api_host} from './config/config.js'
import PostIcon from '@mui/icons-material/Book';
import UserIcon from '@mui/icons-material/Group';

import BookmarksIcon from '@mui/icons-material/Bookmarks';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import BookIcon from '@mui/icons-material/Book';
import CloudIcon from '@mui/icons-material/Cloud';
import HttpIcon from '@mui/icons-material/Http';
import ArtTrackIcon from '@mui/icons-material/ArtTrack';
import { fetchUtils, Admin, Resource, CustomRoutes } from 'react-admin';

import jsonServerProvider from 'ra-data-json-server';
import addUploadFeature from './dataprovider/addUploadFeature.js';

import './App.css';
import Dashboard from './Dashboard';
import authProvider from './authProvider';
import LoginPage from './login/LoginPage'
import MyLayout from './frame/MyLayout'

import { HumanList, HumanShow} from './human/Human';

import { UserList, UserShow} from './users';
import { ProjectList, ProjectEdit, ProjectCreate, ProjectShow} from './project/projects';
import { SketchList, SketchEdit, SketchShow, SketchCreate} from './project/sketchs';
import { ScreenList, ScreenEdit, ScreenCreate, ScreenShow} from './project/screens';
import { BlockList, BlockEdit, BlockCreate, BlockShow} from './project/blocks';

import { ResourceList, ResourceShow, ResourceCreate, ResourceEdit} from './backend/Resource';
import { ResourceHistoryList} from './management/ResourceHistory';
import { ReportList} from './management/Report';

import {Route} from 'react-router-dom';
import BlockCloudJsonView from './project/BlockCloudJsonView';
import BlockCloudHtmlJsonView from './project/BlockCloudHtmlJsonView';
import BlockSketchJsonView from './project/BlockSketchJsonView';
import TokenToSketch from './token/TokenToSketch';
import DraftSample from './market/DraftSample';
import AppLink from './market/AppLink';
import LearnScreen from './learn/LearnScreen';
import Join from './login/Join';
import IDE from './ide/IDE';
import FigmaCallback from './figma/FigmaCallback';
import { DraftList, DraftShow, DraftCreate, DraftEdit} from './market/Draft';
import { LibraryList, LibraryShow} from './market/Library';



const httpClient = (url, options = {}) => {
    if (!options.headers) {
        options.headers = new Headers({ Accept: 'application/json' });
    }
    const token = localStorage.getItem('token');
    options.headers.set('x-access-token', token);
    const devil_project = localStorage.getItem('devil_project');
    options.headers.set('devil_project', devil_project);
    return fetchUtils.fetchJson(url, options);
}

const dataProvider = jsonServerProvider(api_host, httpClient);
const uploadCapableDataProvider = addUploadFeature(dataProvider);

const App = () => {
    const getQueryParams = (query = null) => {
        let a = window.location.href.split('?')
        let r = {}
        if(a.length > 1) {
            let pv_list = a[1].split('&')
            pv_list.map(m=>{
                let pv = m.split('=')
                let p = pv[0]
                let v = pv[1]
                r[p] = decodeURIComponent(v)
            })
        }
        return r
    }
    let {token} = getQueryParams()
    if(token != null) {
        localStorage.setItem('token', token);
    }

    return (
    <Admin
        layout={MyLayout}
        loginPage={LoginPage} 
        dataProvider={uploadCapableDataProvider}
        authProvider={authProvider}
        dashboard={Dashboard}
    >
        <CustomRoutes>
            <Route exact path="/cloud_html_json/:id" element={<BlockCloudHtmlJsonView/>}/>,
            <Route exact path="/cloud_json/:id" element={<BlockCloudJsonView/>}/>,
            <Route exact path="/sketch_block_json/:id" element={<BlockSketchJsonView/>}/>,
            <Route exact path="/token" element={<TokenToSketch/>}/>,
            <Route exact path="/draft_sample" element={<DraftSample/>}/>,
            <Route exact path="/draft/tutorial/:package_id" element={<AppLink/>}/>,
        </CustomRoutes>
        <CustomRoutes noLayout>
            <Route exact path="/learn/screen/:screen_id" element={<LearnScreen/>} />
            <Route exact path="/join" element={<Join/>} />
            <Route exact path="/ide" element={<IDE/>} />
            <Route exact path="/ide/:path" element={<IDE/>} />
            <Route exact path="/figma/login/callback" element={<FigmaCallback/>} />
        </CustomRoutes>

        <Resource name="project" options={{ label: 'Project' }} icon={BookmarksIcon} 
            list={ProjectList} 
            edit={ProjectEdit}
            create={ProjectCreate}
            show={ProjectShow}
        />
        
        <Resource name="screen" options={{ label: 'Screen' }} icon={BookmarkIcon} 
            list={ScreenList} 
            edit={ScreenEdit}
            create={ScreenCreate}
            show={ScreenShow}
        />
        <Resource name="block" options={{ label: 'Block' }} icon={BookIcon} 
            list={BlockList} 
            edit={BlockEdit}
            create={BlockCreate}
            show={BlockShow}
        />
        
        <Resource name="sketch" options={{ label: 'Sketch' }} icon={UserIcon} 
            list={SketchList}
            create={SketchCreate}
            edit={SketchEdit}
            show={SketchShow}
        />

        <Resource name="user" />
        <Resource name="human" list={HumanList} show={HumanShow}/>
        <Resource name="resource" options={{ label: 'Resource' }} 
            list={ResourceList} show={ResourceShow}
            edit={ResourceEdit} create={ResourceCreate}/>
        
        <Resource name="resource_history" options={{ label: 'History' }} icon={ArtTrackIcon}
            list={ResourceHistoryList}/>
        <Resource name="report" options={{ label: 'Report' }} icon={ArtTrackIcon}
            list={ReportList}/>

        <Resource name="test" options={{ label: 'Test' }} icon={UserIcon} list={UserList} show={UserShow}/>
        <Resource name="publish" options={{ label: 'Publish' }} icon={UserIcon} list={UserList} show={UserShow}/>
        
        <Resource name="draft" 
            list={DraftList} 
            edit={DraftEdit}
            create={DraftCreate}
            show={DraftShow}/>

        <Resource name="library" 
            list={LibraryList}
            show={LibraryShow}/>
    </Admin>
  )};

export default App;

